import { ControlInfoEnum } from 'Common/FieldEnum';

export const tabEnum = {
  Info: 'info',
  Settings: 'settings',
  CaseTypes: 'caseTypes',
  TaxRates: 'taxRates',
  Menus: 'menus',
};

export const districtInfoInitialValues = values => {
  return {
    [ControlInfoEnum.DistrictCode]: values.UnitCode,
    [ControlInfoEnum.DistrictName]: values.UnitName,
    [ControlInfoEnum.FiscalYear]: values.FiscalYear,
    [ControlInfoEnum.Address1]: values.Address1,
    [ControlInfoEnum.Address2]: values.Address2,
    [ControlInfoEnum.City]: values.City ? values.City : '',
    [ControlInfoEnum.State]: values.State ? values.State : '',
    [ControlInfoEnum.ZipCode]: values.ZipCode ? values.ZipCode : '',
    [ControlInfoEnum.DirectorTitle]: values.DirectorTitle,
    [ControlInfoEnum.DirectorName]: values.Director,
    [ControlInfoEnum.DirectorAddress1]: values.DirectorAddress1,
    [ControlInfoEnum.DirectorAddress2]: values.DirectorAddress2,
    [ControlInfoEnum.DirectorState]: values.DirectorState
      ? values.DirectorState
      : '',
    [ControlInfoEnum.DirectorCity]: values.DirectorCity
      ? values.DirectorCity
      : '',
    [ControlInfoEnum.DirectorZipCode]: values.DirectorZipCode
      ? values.DirectorZipCode
      : '',
    [ControlInfoEnum.DirectorPhone]:
      values.DirectorPhone &&
      '(' +
        values.DirectorPhone.substr(0, 3) +
        ') ' +
        values.DirectorPhone.substr(3, 3) +
        '-' +
        values.DirectorPhone.substr(6, 4),
    [ControlInfoEnum.DirectorEmail]: values.DirectorEmail,
    [ControlInfoEnum.HearingTitle]: values.HearingOfficialTitle,
    [ControlInfoEnum.HearingName]: values.HearingOfficial,
    [ControlInfoEnum.HearingAddress1]: values.HearingOfficialaddress1,
    [ControlInfoEnum.HearingAddress2]: values.HearingOfficialAddress2,
    [ControlInfoEnum.HearingState]: values.HearingOfficialState
      ? values.HearingOfficialState
      : '',
    [ControlInfoEnum.HearingCity]: values.HearingOfficialCity
      ? values.HearingOfficialCity
      : '',
    [ControlInfoEnum.HearingZipCode]: values.HearingOfficialZipCode
      ? values.HearingOfficialZipCode
      : '',
    [ControlInfoEnum.HearingPhone]:
      values.HearingOfficialPhone &&
      '(' +
        values.HearingOfficialPhone.substr(0, 3) +
        ') ' +
        values.HearingOfficialPhone.substr(3, 3) +
        '-' +
        values.HearingOfficialPhone.substr(6, 4),
    [ControlInfoEnum.HearingEmail]: values.HearingOfficialEmail,
  };
};

export const districtSettingsInitialValues = values => {
  return {
    [ControlInfoEnum.Category1]: values.ReleaseCategory1,
    [ControlInfoEnum.Category2]: values.ReleaseCategory2,
    [ControlInfoEnum.Category3]: values.ReleaseCategory3,
    [ControlInfoEnum.Category4]: values.ReleaseCategory4,
    [ControlInfoEnum.Category5]: values.ReleaseCategory5,
    [ControlInfoEnum.Category6]: values.ReleaseCategory6,
    [ControlInfoEnum.Category7]: values.ReleaseCategory7,
    [ControlInfoEnum.Category8]: values.ReleaseCategory8,
    [ControlInfoEnum.Category9]: values.ReleaseCategory9,
    [ControlInfoEnum.AttendanceFactor]: values.AttendanceFactor,
    [ControlInfoEnum.HHName]: values.ScanHHName === 'N' ? false : true,
    [ControlInfoEnum.HHSsn]: values.ScanHHSSN === 'N' ? false : true,
    [ControlInfoEnum.StudentSsn]: values.ScanStuSSN === 'N' ? false : true,
    [ControlInfoEnum.CaseNumber]:
      values.ScanStuCaseNumber === 'N' ? false : true,
    [ControlInfoEnum.ProvisionType]: values.ProvisionTypeDefault.toString(),
    [ControlInfoEnum.ServingNum]: values.GenerateServingNum,
    [ControlInfoEnum.StartsWith]: values.StartingServingNum,
    [ControlInfoEnum.SpecialMessage]: values.SpecialServingMessage,
    [ControlInfoEnum.Allergens]: values.AllergenMessage,
    [ControlInfoEnum.RequireSecondReview]: values.RequireSecondReview,
    [ControlInfoEnum.RequireSecondReviewCompleteToPrint]:
      values.RequireSecondReviewCompleteToPrint,
    [ControlInfoEnum.TimeZone]: values.ZonesId,
    [ControlInfoEnum.EnableLPP]: values.EnableLPP === 'N' ? false : true,
    [ControlInfoEnum.ReprocessTransactions]:
      values[ControlInfoEnum.ReprocessTransactions],
    [ControlInfoEnum.INV_AppEnabled]: values[ControlInfoEnum.INV_AppEnabled],
  };
};

export const districtInfoSubmitValues = values => {
  return {
    UnitCode: values[ControlInfoEnum.DistrictCode],
    UnitName: values[ControlInfoEnum.DistrictName],
    FiscalYear: values[ControlInfoEnum.FiscalYear],
    Address1: values[ControlInfoEnum.Address1],
    Address2: values[ControlInfoEnum.Address2],
    City: values[ControlInfoEnum.City],
    State: values[ControlInfoEnum.State],
    ZipCode: values[ControlInfoEnum.ZipCode],
    DirectorTitle: values[ControlInfoEnum.DirectorTitle],
    Director: values[ControlInfoEnum.DirectorName],
    DirectorAddress1: values[ControlInfoEnum.DirectorAddress1],
    DirectorAddress2: values[ControlInfoEnum.DirectorAddress2],
    DirectorState: values[ControlInfoEnum.DirectorState],
    DirectorCity: values[ControlInfoEnum.DirectorCity],
    DirectorZipCode: values[ControlInfoEnum.DirectorZipCode],
    DirectorPhone:
      values[ControlInfoEnum.DirectorPhone] &&
      values[ControlInfoEnum.DirectorPhone].length > 0
        ? values[ControlInfoEnum.DirectorPhone].replace(/[^a-z0-9]+/g, '')
        : '',
    DirectorEmail: values[ControlInfoEnum.DirectorEmail],
    HearingOfficialTitle: values[ControlInfoEnum.HearingTitle],
    HearingOfficial: values[ControlInfoEnum.HearingName],
    HearingOfficialaddress1: values[ControlInfoEnum.HearingAddress1],
    HearingOfficialAddress2: values[ControlInfoEnum.HearingAddress2],
    HearingOfficialState: values[ControlInfoEnum.HearingState],
    HearingOfficialCity: values[ControlInfoEnum.HearingCity],
    HearingOfficialZipCode: values[ControlInfoEnum.HearingZipCode],
    HearingOfficialPhone:
      values[ControlInfoEnum.HearingPhone] &&
      values[ControlInfoEnum.HearingPhone].length > 0
        ? values[ControlInfoEnum.HearingPhone].replace(/[^a-z0-9]+/g, '')
        : '',
    HearingOfficialEmail: values[ControlInfoEnum.HearingEmail],
  };
};

export const districtSettingsSubmitValues = values => {
  return {
    ReleaseCategory1: values[ControlInfoEnum.Category1],
    ReleaseCategory2: values[ControlInfoEnum.Category2],
    ReleaseCategory3: values[ControlInfoEnum.Category3],
    ReleaseCategory4: values[ControlInfoEnum.Category4],
    ReleaseCategory5: values[ControlInfoEnum.Category5],
    ReleaseCategory6: values[ControlInfoEnum.Category6],
    ReleaseCategory7: values[ControlInfoEnum.Category7],
    ReleaseCategory8: values[ControlInfoEnum.Category8],
    ReleaseCategory9: values[ControlInfoEnum.Category9],
    AttendanceFactor: values[ControlInfoEnum.AttendanceFactor]
      ? values[ControlInfoEnum.AttendanceFactor]
      : 0,
    ScanHHName: values[ControlInfoEnum.HHName] === false ? 'N' : 'Y',
    ScanHHSSN: values[ControlInfoEnum.HHSsn] === false ? 'N' : 'Y',
    ScanStuSSN: values[ControlInfoEnum.StudentSsn] === false ? 'N' : 'Y',
    ScanStuCaseNumber: values[ControlInfoEnum.CaseNumber] === false ? 'N' : 'Y',
    ProvisionTypeDefault: values[ControlInfoEnum.ProvisionType],
    GenerateServingNum: values[ControlInfoEnum.ServingNum],
    StartingServingNum: values[ControlInfoEnum.StartsWith],
    SpecialServingMessage: values[ControlInfoEnum.SpecialMessage],
    AllergenMessage: values[ControlInfoEnum.Allergens],
    RequireSecondReview: values[ControlInfoEnum.RequireSecondReview],
    RequireSecondReviewCompleteToPrint:
      values[ControlInfoEnum.RequireSecondReviewCompleteToPrint],
    ZonesId: values[ControlInfoEnum.TimeZone],
    EnableLPP: values[ControlInfoEnum.EnableLPP] === false ? 'N' : 'Y',
    [ControlInfoEnum.ReprocessTransactions]:
      values[ControlInfoEnum.ReprocessTransactions],
    INV_AppEnabled: values[ControlInfoEnum.INV_AppEnabled],
  };
};

export const purchaseOrderInfoInitialValues = values => {
  return {
    [ControlInfoEnum.NextPONumber]: values.NextPONumber
      ? values.NextPONumber
      : 0,
    [ControlInfoEnum.POStatement]: values.POStatement,
    [ControlInfoEnum.Signature_FinanceOfficer]: values.Signature_FinanceOfficer,
  };
};

export const purchaseOrderInfoSubmitValues = values => {
  return {
    NextPONumber: values[ControlInfoEnum.NextPONumber]
      ? values[ControlInfoEnum.NextPONumber]
      : 0,
    POStatement: values[ControlInfoEnum.POStatement],
    Signature_FinanceOfficer: values[ControlInfoEnum.Signature_FinanceOfficer],
  };
};

export const menusSubmitValues = values => {
  return {
    [ControlInfoEnum.ApplyCycleBehavior_MNU]:
      values[ControlInfoEnum.ApplyCycleBehavior_MNU],
    [ControlInfoEnum.UpdateINV_MNU]: values[ControlInfoEnum.UpdateINV_MNU],
    [ControlInfoEnum.ShowINV_MNU]: values[ControlInfoEnum.ShowINV_MNU],
  };
};

export const menusFormInitialValues = values => {
  return {
    [ControlInfoEnum.ApplyCycleBehavior_MNU]:
      values[ControlInfoEnum.ApplyCycleBehavior_MNU],
    [ControlInfoEnum.UpdateINV_MNU]: values[ControlInfoEnum.UpdateINV_MNU],
    [ControlInfoEnum.ShowINV_MNU]: values[ControlInfoEnum.ShowINV_MNU],
  };
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/helpers/ControlInfoObjects.js